import { render, staticRenderFns } from "./RoleContent.vue?vue&type=template&id=e697b73a"
import script from "./RoleContent.vue?vue&type=script&lang=js"
export * from "./RoleContent.vue?vue&type=script&lang=js"
import style0 from "./RoleContent.vue?vue&type=style&index=0&id=e697b73a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports